import { connect } from 'react-redux';
import { actionGetBookingList } from 'store/booking/actions';
import { GET_MY_PLACE } from 'store/place/actionTypes';

import ManagerBooking from './ManagerBooking';

const mapStateToProps = (state) => ({
  loadingBookingList: state.Booking.loadingBookingList,
  isLoadingGetMyPlace: state.Place.isLoadingGetMyPlace,

  myPlace: state.Place.myPlace,
  bookingList: state.Booking.bookingList,
  bookingTotal: state.Booking.bookingTotal,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetBookingList: (payload) => dispatch(actionGetBookingList(payload)),

  actionGetMyPlace: (payload) => dispatch({
    type: GET_MY_PLACE,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerBooking);
